// src/hooks/useOfficialSectionSettings.js
// Ana səhifə «Rəsmi Top-Up» bölməsinin admin ayarlarını (public /site-settings)
// bir dəfə çəkir (modul-səviyyə keş) və komponentə verir. Ayarlar yüklənənədək
// default dəyərlər qaytarılır → mövcud davranış pozulmur.
import { useEffect, useState } from 'react'
import api from '../api/api'

export const OFFICIAL_SECTION_DEFAULTS = {
    enabled: true,
    hideIfEmpty: true,
    title: 'Rəsmi Top-Up və E-Pin',
    subtitle: 'UC, VP, gift card və abunəlikləri rəsmi xidmətlərdən təhlükəsiz al.',
    chipText: 'ITEMZO RƏSMİ',
    maxItems: 4,
    styleVariant: 'compact',
    showTabs: true,
    showViewAllButton: true,
}

let cache = null
let inflight = null
const subs = new Set()
const notify = () => subs.forEach((fn) => fn(cache))

const fetchOnce = () => {
    if (inflight) return inflight
    inflight = api.get('/site-settings')
        .then(({ data }) => {
            const ocs = data?.data?.officialCatalogSection || {}
            cache = { ...OFFICIAL_SECTION_DEFAULTS, ...ocs }
            notify()
            return cache
        })
        .catch(() => cache)
        .finally(() => { inflight = null })
    return inflight
}

export const useOfficialSectionSettings = () => {
    const [state, setState] = useState(cache || OFFICIAL_SECTION_DEFAULTS)
    useEffect(() => {
        subs.add(setState)
        if (cache) setState(cache)
        else fetchOnce()
        return () => { subs.delete(setState) }
    }, [])
    return state
}
